var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProcoreLogo = function SvgProcoreLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 68.44"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Procore_Logo_Graphicmark_1C_Black_RGB")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "PROCORE_GRAPHICMARK",
    "data-name": "PROCORE GRAPHICMARK",
    d: "M108,81.17V92.26a13.52,13.52,0,0,1-14,14H50a13.52,13.52,0,0,1-14-14V51.74a13.52,13.52,0,0,1,14-14H94a13.52,13.52,0,0,1,14,14V62.83H91.6L84.46,50.51H59.54L47.09,72,59.54,93.49H84.46L91.6,81.17ZM65.25,60.35,58.49,72l6.76,11.65h13.5L85.5,72,78.75,60.35Z",
    transform: "translate(-36 -37.78)"
  })));
};
export default SvgProcoreLogo;